import { useMemo } from 'react';
import { getPhaseForDocumentType, getPhaseOrder } from 'utils/constants/projectPhases';
import type { SelectionTreeNode, DataMap } from 'state/filterToolbar';

export const useLatestProjectStageFilter = ({ options }: { options: DataMap }) => {
  const optionsGroupedByPhase = useMemo(() => {
    const optionsByPhase: Record<string, SelectionTreeNode[]> = {};
    Object.values(options).forEach((option: SelectionTreeNode) => {
      const phase = getPhaseForDocumentType(option.label);
      if (!optionsByPhase[phase]) {
        optionsByPhase[phase] = [];
      }
      optionsByPhase[phase].push(option);
    });

    // Sort options within each phase
    Object.keys(optionsByPhase).forEach((phase) => {
      optionsByPhase[phase].sort((a, b) => {
        return getPhaseOrder(phase, a.label) - getPhaseOrder(phase, b.label);
      });
    });

    return optionsByPhase;
  }, [options]);

  return { optionsGroupedByPhase };
};
